import { AskStatus } from './types';

export default Object.freeze({
  category: 'GET_STARTED',
  messages: [],
  status: AskStatus.IDLE,
  error: null,
  feedback: {},
  monthlyTokensUsed: 0,
  monthlyTokenLimit: 0,
  monthlyTokensRemaining: 0,
});
